<style>
	.bg343 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar5{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%; }
.tabbar5 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar5 span.pos{  padding:0 1vw;}
.tabbar5 span.floder{ color:#666;}
 
.tabbar5 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}

.interact_right{width:64vw;height: 45vw;background-color: #fffff9;margin: 0;padding: 0;overflow: hidden;margin-top:6vw;float: left;
border: #e3e3e3 solid 1px;box-sizing: border-box; border-left: 0;} 
.interact_right input.h_title{width: 60vw;margin: 0 auto;height: 5vw;display: block;border: 0;border-bottom: #ddd solid 1px;border-radius: 0;
font-size: 1.6vw;color: #3465ff;}
.interact_right input.h_title::placeholder{color: #3465ff;}
.vote_content{width: 60vw;height: 15vw;margin: 0 auto;border-bottom:#ddd solid 1px;overflow: hidden;}
.vote_content textarea{width: 60vw;height: 15vw;border: 0;line-height: 2vw;font-size: 1.5vw;outline: none;border: 0;}
.vote_content textarea::placeholder{font-size: 1.5vw;color: #999;line-height: 2vw;}

.vote_point{width: 60vw;height: 15vw;margin: 0 auto;border-bottom:#ddd solid 1px;overflow: hidden;}
.vote_point textarea{width: 29vw;height: 12vw;border: 0;line-height: 2vw;font-size: 1.5vw;outline: none;border: 0;float: left;margin-top: 1.5vw;}
.vote_point textarea::placeholder{font-size: 1.5vw;color: #999;line-height: 2vw;}
.vote_point span.ge{width: 1vw;height: 12vw;border-left:#ddd solid 1px ;display: block;float: left;margin-top:1.5vw;}

.vote_fun{width: 60vw;height: 10vw;}
.vote_fun span{display: block;height: 3vw;line-height: 3vw;font-size: 1.4vw;text-align: left;font-size: 1.4vw;}
.vote_thum{width:15vw;height: 5vw;float: left;border: #ddd dashed 1px;box-sizing: border-box;}
.vote_thum img.jia{display: block;width: 2vw;margin: 0 auto;margin-top: .5vw;}
.vote_thum img.tu{display: block;width: 15vw;margin: 0 auto;margin-top: 0;height: 5vw;}
.vote_thum span{font-size: 1.2vw;display: block;text-align: center;width: 100%;line-height: 2vw;}
.vote_fun button{background: #8cb4ec;width: 15vw;height: 5vw;border: 0;outline: none;float:left;margin-left: 1vw;
color: #fff;font-size: 1.6vw;}
</style>
<template>
	<div class="bg343">

         
	     <u_center></u_center>
	     <interact :main="main" :sub="sub" :title="title"></interact>
	     <div class="interact_right">
	     	 <input type="text" class="h_title" placeholder="请输入投票标题（5~30个字）">
	     	 <div class="vote_content">
	     	 	<textarea placeholder="输入投票说明:"></textarea>
	     	 </div>
	     	 <div class="vote_point">
	     	 	<textarea class="agree" placeholder="输入正方观点:"></textarea>
	     	 	<span class="ge"></span>
	     	 	<textarea placeholder="输入反方观点:"></textarea>
	     	 </div>
	     	 <div class="vote_fun">
	     	 	<span>封面和摘要</span>
	     	 	<div class="vote_thum">
	     	 		<img class="jia" src="../../../static/images/jia.png" v-if="!uploaded">
	     	 		<span v-if="!uploaded">请选择封面</span>
	     	 		<img class="tu" src="../../../static/images/tu.png" v-if="uploaded">
	     	 	</div>
	     	 	<button>发布</button>
	     	 </div>
		 </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import interact from '@/components/interact.vue'; 
	export default {
	    components: {
		  u_center,
		  interact
	    },
		data() {
			return {
				token:"",
				main:2,
				sub:"",
				title:"新增投票",
				uploaded:false
			}
		},
		mounted() {
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  
			  } 

		},
		methods: {
			vote_add(){
                   this.$router.push("/vote_add");  
			},
			 add_template(){	 
              if(!this.sign_selected){
              	  this.$toast.center('请选择签名');
              	  return;
              }
		      let self=this;
			  self.$loading('提交中...');
		      axios.post(this.$api+'/message/add_template', {
					   token:self.token,
					   type:self.type,
					   content:self.content,
					   signname:self.signname
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){
				             self.$toast.center('添加成功，请等待审核');	
                             setTimeout(function(){
								        self.$loading.close();
										self.back();
					         },1000);				  
					 		 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  }else{
				     self.$loading.close();
				     self.$toast.center(data.msg);	
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		},watch:{
			   content(){
			     this.current_length=  this.$refs.count.value.length; 		      
			     this.count=Math.ceil(this.current_length/70);
			   }
              
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/interact/vote_add.vue